import { render, staticRenderFns } from "./specialPropsFlow.vue?vue&type=template&id=5726fb24&scoped=true"
import script from "./specialPropsFlow.vue?vue&type=script&lang=js"
export * from "./specialPropsFlow.vue?vue&type=script&lang=js"
import style0 from "./specialPropsFlow.vue?vue&type=style&index=0&id=5726fb24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5726fb24",
  null
  
)

export default component.exports